export default "https://assets.pclncdn.com/web/next-landing/04b488bed1/_next/static/images/denver-7490a37761cf8d417b8f6c6d8f8f90c7.jpg";